import { ArticleParagraph2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IAboutBuildingMultiAdsProps extends React.PropsWithChildren {
  isBooked?: boolean;
}

export const AboutBuildingMultiAds: React.FC<IAboutBuildingMultiAdsProps> = ({ children, isBooked }) => {
  /* istanbul ignore next */
  const color = isBooked ? 'text-secondary-default' : 'text-primary-default';

  return (
    <div className={styles['wrapper']}>
      <ArticleParagraph2 as="p" color={color}>
        {children}
      </ArticleParagraph2>
    </div>
  );
};
